<template>
    <div v-click-outside="onCloseTags" :class="{ 'footer-tags': true, [`footer-tags--${variant}`]: true }">
        <div :class="{ 'footer-tags__popup': true, 'footer-tags__popup--active': showAllTags }" @click.stop>
            <div
                :class="{ 'footer-tags__tags': true, 'footer-tags__tags--expanded': !showAllTags }"
                v-if="!showAllTags"
            >
                <Tag v-for="tag in firstTags" :key="tag.id" :tag="tag" />
            </div>

            <TagsDropdownButton v-if="showArrowButton && !showAllTags" @click="onShowTags" />

            <div class="footer-tags__tags" v-if="showAllTags">
                <Tag v-for="tag in tags" :key="tag.id" :tag="tag" />

                <TagsDropdownButton v-if="showArrowButton" @click="onCloseTags" style="transform: rotate(180deg)" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Tag from './Tag.vue';
import TagsDropdownButton from './TagsDropdownButton.vue';

export default {
    components: {
        Tag,
        TagsDropdownButton,
    },

    props: {
        entityId: {
            type: [String, Number],
            required: true,
        },

        expandedEntityId: {
            type: [String, Number],
            default: null,
        },

        foreignCompetenceIds: {
            type: Array,
            default: () => [],
        },

        foreignCourseAreasId: {
            type: Array,
            default: () => [],
        },

        variant: {
            type: String,
            default: 'white',
        },
    },

    data() {
        return {
            tags: [],
            showAllTags: false,
            showArrowButton: false,
        };
    },

    computed: {
        ...mapGetters('track', ['userCompetencies', 'userCourseAreas', 'userCompetenciesMap', 'userCourseAreasMap']),

        firstTags() {
            return this.tags.slice(0, 6);
        },
    },
    methods: {
        onCloseTags() {
            this.showAllTags = false;
        },

        onEmitExpandTags() {
            this.$emit('onExpandedTags', this.entityId);
        },

        onShowTags() {
            this.onEmitExpandTags();
            this.showAllTags = true;
        },

        countVisibleTags() {
            this.$nextTick(() => {
                const container = this.$el.querySelector('.footer-tags__tags--expanded');
                if (!container) return;

                const containerBottom = container.getBoundingClientRect().bottom;
                const tagElements = container.querySelectorAll('.tag');

                let visibleCount = 0;

                tagElements.forEach((tagEl) => {
                    const tagRect = tagEl.getBoundingClientRect();
                    if (tagRect.bottom <= containerBottom) {
                        visibleCount++;
                    }
                });

                this.showArrowButton = visibleCount < this.tags.length;
            });
        },
    },
    watch: {
        expandedEntityId() {
            if (this.expandedEntityId !== this.entityId) {
                this.showAllTags = false;
            }
        },
    },

    mounted() {
        const foreign_competence = this.foreignCompetenceIds.reduce((acc, id) => {
            if (this.userCompetenciesMap[id]) acc.push(this.userCompetenciesMap[id]);
            return acc;
        }, []);

        const foreign_course_area = this.foreignCourseAreasId.reduce((acc, id) => {
            if (this.userCourseAreasMap[id]) acc.push(this.userCourseAreasMap[id]);
            return acc;
        }, []);

        this.tags = [...foreign_course_area, ...foreign_competence];

        this.$nextTick(this.countVisibleTags);
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.footer-tags {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    &__popup {
        background-color: white;
        padding: urem(10) urem(18) urem(14) urem(18);
        z-index: 110;
        border-bottom-left-radius: urem(16);
        border-bottom-right-radius: urem(16);
        width: 100%;
        position: relative;
        height: urem(120);

        &--active {
            height: auto;
            z-index: 500;

            .footer-tags__tags {
                padding-bottom: urem(25);
            }
        }
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;
        gap: urem(8);
        border-top: 1px solid rgba(207, 227, 245, 1);
        padding-top: urem(16);

        &--expanded {
            overflow: hidden;
            height: urem(70);

            :deep(.tag) {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: urem(300);

                @include on-desktop {
                    max-width: urem(200);
                }
            }
        }
    }
}
</style>
